import HouseDetail from "../components/HouseDetail";
import {connect} from "react-redux";
import {
	assignModuleToHouse,
	deleteHouse, fetchActiveWorkersCount, fetchKfzOfHouse,
	fetchModulesOfHouse,
	loadHouse, loginAsSupport,
	regenerateHouse, removeLogoOfHouse, resetSupportLogin, revokeModuleFromHouse, savePaymentOfHouse,
	updateHouse, updateKfzOfHouse, uploadLogoForHouse
} from "../actions/houseActions";
import {isOnline} from "../actions/userActions";
import {loadTimezones} from "../actions/timezoneActions";
import {push} from "react-router-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_DELETE_HOUSE, PROC_MODULE_FOR_HOUSES, PROC_UPDATE_HOUSE} from "../actions/index";
import {showSnackbar} from "../actions/snachbarActions";
import {fetchModules} from "../actions/moduleActions";
import {fetchKfzList} from "../actions/kfzActions";
import isFunc from 'lodash/isFunction';
import {PROC_SUPPORT_LOGIN} from "../actions";

const m2s = (state, props) => {
	const house_id = Number(props.match.params.house_id);
	const house = state.house.list.find(house => house.house_id === house_id);
	const house2kfz = house ? house.kfz : [];
	return ({
		house,
		loadingSupport: isProcessing(state, PROC_SUPPORT_LOGIN, house_id),
		supportReady: state.support === house_id,
		kfz_list: state.kfz.list,
		house2kfz,
		timezones: state.timezones,
		modules: state.modules.list,
		isModuleAction: isProcessing(state, PROC_MODULE_FOR_HOUSES, props.match.params.house_id),
		isUpdating: isProcessing(state, PROC_UPDATE_HOUSE, props.match.params.house_id),
		isDeleting: isProcessing(state, PROC_DELETE_HOUSE, props.match.params.house_id)
	});
};
const m2d = (dispatch, props) => {
	console.info('Props of HDC', props);
	const house_id = Number(props.match.params.house_id);
	dispatch(isOnline(() => {
		dispatch(loadHouse(house_id, () => {
			dispatch(fetchModulesOfHouse(house_id));
			dispatch(fetchKfzOfHouse(house_id));
			dispatch(fetchActiveWorkersCount(house_id));
		}));
		dispatch(fetchKfzList());
		dispatch(fetchModules());
		dispatch(loadTimezones());
	}));
	return {
		onUpdate: (house, onSuccess) => dispatch(updateHouse(house, () => {
			isFunc(onSuccess) && onSuccess();
			dispatch(showSnackbar('snackbar.house.edited'));
		})),
		onBack: () => dispatch(push('/houses')),
		onDelete: (id, onSuccess) => dispatch(deleteHouse(id, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.deleted'));
			// dispatch(push('/houses'));
		})),
		onRegenerate: (house, onSuccess) => dispatch(regenerateHouse(house, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.regenerated'));
		})),
		showSnackbar: (what, type) => dispatch(showSnackbar(what, type)),
		onAssignModule: (module, house, onSuccess) => dispatch(assignModuleToHouse(module, house, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.modules.assigned'));
		})),
		onRevokeModule: (module, house, onSuccess) => dispatch(revokeModuleFromHouse(module, house, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.modules.revoked'));
		})),
		onUpdatePayment: (house, onSuccess) => dispatch(savePaymentOfHouse(house, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.payment-updated'));
		})),
		onUpdateKfz: (house, kfz_list, onSuccess) => dispatch(updateKfzOfHouse(house, kfz_list, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.kfz-updated'));
		})),
		onUploadLogo: (house, image, onSuccess) => dispatch(uploadLogoForHouse(house, image, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.logo-uploaded'));
		})),
		onDeleteLogo: (house, onSuccess) => dispatch(removeLogoOfHouse(house, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.house.logo-removed'));
		})),
		onSupportLogin: (onSuccess) => dispatch(loginAsSupport(house_id, () => {
			isFunc(onSuccess) && onSuccess();
			dispatch(showSnackbar('snackbar.support.login'));
		})),
		onResetSupportLogin: () => dispatch(resetSupportLogin())
	};
};
export default connect(m2s, m2d)(HouseDetail);


// WEBPACK FOOTER //
// ./src/containers/HouseDetailController.js